const TanzaniaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112531)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#FFDA44"
      />
      <path
        d="M5.85809 34.1415C6.69707 34.9805 7.59223 35.7287 8.53121 36.3874L36.3882 8.53031C35.7296 7.59133 34.9814 6.69617 34.1424 5.85719C33.3033 5.0182 32.4082 4.27008 31.4693 3.61133L3.6123 31.4684C4.2709 32.4072 5.01918 33.3024 5.85809 34.1415Z"
        fill="black"
      />
      <path
        d="M5.85802 5.8589C-0.451515 12.1686 -1.66284 21.6444 2.22177 29.1712L29.1704 2.22273C21.6436 -1.66188 12.1676 -0.450478 5.85802 5.8589Z"
        fill="#6DA544"
      />
      <path
        d="M34.1423 34.1414C40.4519 27.8319 41.6631 18.3559 37.7787 10.8291L10.8301 37.7777C18.3567 41.6623 27.8327 40.451 34.1423 34.1414Z"
        fill="#338AF3"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112531">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default TanzaniaSvg;
